// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.service.costandfees.enums.FeeApplicableLevelType

export enum FeeApplicableLevelType {
  BUILDING = 'BUILDING',
  FLOOR_PLAN = 'FLOOR_PLAN',
  UNIT = 'UNIT',
}

export const FeeApplicableLevelType_values = [
  FeeApplicableLevelType.BUILDING,
  FeeApplicableLevelType.FLOOR_PLAN,
  FeeApplicableLevelType.UNIT,
] as const;
